import moment from 'moment';

import { DATE_FORMAT } from 'utils/constants';

// A Work Order's Start Date / End Date fields (Schedule bar). The End Date can't be before the Start
// Date; the same day is fine. The tasks API enforces this too.
export const SCHEDULE_START_DATE_SLUG = 'schedule_start_date';
export const SCHEDULE_END_DATE_SLUG = 'schedule_end_date';

const OTHER_SCHEDULE_DATE_SLUG: Record<string, string> = {
  [SCHEDULE_START_DATE_SLUG]: SCHEDULE_END_DATE_SLUG,
  [SCHEDULE_END_DATE_SLUG]: SCHEDULE_START_DATE_SLUG,
};

/** The other schedule date field of a Start Date / End Date field, undefined for any other field */
export const getOtherScheduleDateSlug = (slug: string): string | undefined =>
  OTHER_SCHEDULE_DATE_SLUG[slug];

// A picked (Moment) or stored (YYYY-MM-DD) date as YYYY-MM-DD, so dates compare as calendar days
const toDay = (value: unknown): string | null => {
  if (!value) {
    return null;
  }
  const date = moment.isMoment(value) ? value : moment.utc(String(value));
  return date.isValid() ? date.format(DATE_FORMAT) : null;
};

/**
 * Whether `date` as the value of the field `slug` would put the End Date before the Start Date
 * @param slug The field being set: schedule_start_date or schedule_end_date
 * @param date Its new value
 * @param otherDate The other field's current value
 */
export const isScheduleDateOutOfOrder = (
  slug: string,
  date: unknown,
  otherDate: unknown
): boolean => {
  const day = toDay(date);
  const other = toDay(otherDate);
  if (!day || !other) {
    return false;
  }
  if (slug === SCHEDULE_START_DATE_SLUG) {
    return day > other;
  }
  if (slug === SCHEDULE_END_DATE_SLUG) {
    return day < other;
  }
  return false;
};
